module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/downVector.59178aac.svg";